import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "admin-layout" }
const _hoisted_2 = { class: "admin-layout__sidebar" }
const _hoisted_3 = { class: "admin-layout__nav" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "admin-layout__main" }
const _hoisted_6 = { class: "admin-layout__header" }
const _hoisted_7 = { class: "admin-layout__content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AdminOverview = _resolveComponent("AdminOverview")!
  const _component_UserManagement = _resolveComponent("UserManagement")!
  const _component_TaskManagement = _resolveComponent("TaskManagement")!
  const _component_PointsLog = _resolveComponent("PointsLog")!
  const _component_FeedbackManagement = _resolveComponent("FeedbackManagement")!
  const _component_WorkerManagement = _resolveComponent("WorkerManagement")!
  const _component_QualitySettings = _resolveComponent("QualitySettings")!
  const _component_CouponManagement = _resolveComponent("CouponManagement")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("aside", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "admin-layout__brand" }, [
        _createElementVNode("span", null, "运营后台")
      ], -1)),
      _createElementVNode("nav", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuItems, (item) => {
          return (_openBlock(), _createElementBlock("button", {
            key: item.key,
            type: "button",
            class: _normalizeClass(['admin-layout__nav-item', { 'admin-layout__nav-item--active': _ctx.activeMenu === item.key }]),
            onClick: ($event: any) => (_ctx.activeMenu = item.key)
          }, _toDisplayString(item.label), 11, _hoisted_4))
        }), 128))
      ])
    ]),
    _createElementVNode("main", _hoisted_5, [
      _createElementVNode("header", _hoisted_6, [
        _createElementVNode("h1", null, _toDisplayString(_ctx.pageTitle), 1),
        _createElementVNode("button", {
          type: "button",
          class: "admin-layout__back",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/')))
        }, "返回对话")
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_ctx.activeMenu === 'overview')
          ? (_openBlock(), _createBlock(_component_AdminOverview, {
              key: 0,
              onNavigate: _ctx.navigateTo
            }, null, 8, ["onNavigate"]))
          : (_ctx.activeMenu === 'users')
            ? (_openBlock(), _createBlock(_component_UserManagement, { key: 1 }))
            : (_ctx.activeMenu === 'tasks')
              ? (_openBlock(), _createBlock(_component_TaskManagement, { key: 2 }))
              : (_ctx.activeMenu === 'points')
                ? (_openBlock(), _createBlock(_component_PointsLog, { key: 3 }))
                : (_ctx.activeMenu === 'feedbacks')
                  ? (_openBlock(), _createBlock(_component_FeedbackManagement, { key: 4 }))
                  : (_ctx.activeMenu === 'workers')
                    ? (_openBlock(), _createBlock(_component_WorkerManagement, { key: 5 }))
                    : (_ctx.activeMenu === 'quality')
                      ? (_openBlock(), _createBlock(_component_QualitySettings, { key: 6 }))
                      : (_ctx.activeMenu === 'coupons')
                        ? (_openBlock(), _createBlock(_component_CouponManagement, { key: 7 }))
                        : _createCommentVNode("", true)
      ])
    ])
  ]))
}